import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import AgentTopHeadScreen from "../../component/layout/agent-header";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import { BsHourglassSplit } from "react-icons/bs";
import { LuEye } from "react-icons/lu";
import { SlBriefcase } from "react-icons/sl";
import { RiCalendarScheduleLine } from "react-icons/ri";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { LocalAgentDashboard } from "../../config/LocalAgentDashboard";
import { localAgentDashboard } from "../../service/apis/dashboard.api";
import moment from "moment";
import { AppRoute } from "../../router/routerConstants";
import Loader from "../../common/Loader/loader";
import DataTable from "../../common/data-table";
import MessageList from "../jobseeker/common/message-list";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { showError } from "../../utils/Common";

const AgntDashboardScreen = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [isLoading, setIsLoading] = useState(false);
  const [dashboardDetails, setDashboardDetails] =
    useState<LocalAgentDashboard | null>();
  const { messageList, chatHistory } = useSelector(
    (state: RootState) => state.chatSlice
  );
  const { user } = useSelector((state: RootState) => state.authSlice);
  const [recentPostJobsTableData, setRecentPostJobsTableData] = useState([]);
  const [NavigateTo] = useCustomNavigate();
  const columns = [
    { label: "Jobs", key: "jobs" },
    { label: "Applicants", key: "applicants" },
    { label: "Shortlisted", key: "shortlisted" },
    { label: "Rejected", key: "rejected" },
    { label: "Hired", key: "hired" },
    { label: "View Applicant", key: "view_applicant" },
    { label: "Actions", key: "actions" },
  ];

  useEffect(() => {
    getDashboard();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getDashboard = async () => {
    try {
      setIsLoading(true);
      const response = await localAgentDashboard();
      setDashboardDetails(response?.data);
      const transformed = await transformedData(
        response?.data?.recentApplication
      );
      setRecentPostJobsTableData(transformed);
    } catch (error: any) {
      showError(error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const transformedData = async (applicants: any = []) => {
    return (
      applicants &&
      applicants.map((app: any, index: number) => ({
        jobs: (
          <>
            <div className="profileholdertable d-flex">
              <h4>{app?.title || "N/A"}</h4>
            </div>
            <p className="postdate">
              Created on :{" "}
              {app?.createdAt
                ? moment(app?.createdAt).format("DD MMM YYYY")
                : "N/A"}{" "}
              Expires on :{" "}
              {app?.deadlineDate
                ? moment(app?.deadlineDate).format("DD MMM YYYY")
                : "N/A"}
            </p>
          </>
        ),

        applicants: app?.applicationsSummary?.applied || 0,
        shortlisted: app?.applicationsSummary?.shortlisted || 0,
        rejected: app?.applicationsSummary?.rejected || 0,
        hired: app?.applicationsSummary?.hired || 0,
        view_applicant: (
          <div>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              className={`moreview `+(app?.applicationsSummary?.applied>0?``:`disabled`)}
              onClick={() => app?.applicationsSummary?.applied > 0 && handleView(app)}
              style={app?.applicationsSummary?.applied > 0 ? { cursor: "pointer", textDecoration: "underline" }: undefined}
            >
              View Applicates
            </a>
          </div>
        ),
        actions: (
          <div>
            <button
              className="btnnoStyle btn btn-primary"
              onClick={() => handleView(app)}
              style={{ marginRight: "10px" }}
            >
              <LuEye />
            </button>
            {/* <button
            className="btn btn-danger"
            onClick={() => handleDelete(app)}
            style={{ marginRight: "10px" }}
          >
            <AiOutlineDelete />
          </button> */}
          </div>
        ),
      }))
    );
  };

  const handleView = async (row: any) => {
    NavigateTo(AppRoute.AGENT_APPLICATIONS, false, { jobId: row?._id });
  };

  // const handleDelete = async (row: any) => {
  //   Alert.confirm(
  //     "Delete Job",
  //     `<p>Are you sure you want to delete this job?</p>
  //     <p>After deletion, you will no longer be able to access this job.</p>`
  //   ).then(async (resp) => {
  //     if (resp) {
  //       try {
  //         const response = await DeleteJobApi(row._id);
  //         getDashboard();
  //         showSuccess(response?.message);
  //       } catch (err: any) {
  //         showError(err?.message);
  //       } finally {
  //         // setLoading(false);
  //       }
  //     }
  //   });
  // };

  return (
    <>
      <div className="main">
        <section className="profileJoblisting-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar position-relative p-0">
                <AgentSidebarScreen />
              </div>
              <div className="col-lg-10 rightcontent p-0">
                <AgentTopHeadScreen />
                {isLoading ? (
                  <Loader />
                ) : (
                  <div className="profileJoblisting-holder rightInnerScroll">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="applied-title">
                          <div className="title">
                            <h2>Overview</h2>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="overviewCard">
                          <div className="overviewCardholder">
                            <div className="iconbox">
                              <SlBriefcase />
                            </div>
                            <h2 className="redtext">
                              {" "}
                              {dashboardDetails?.totalApplications || 0}
                            </h2>
                          </div>
                          <h4>Total Applied Jobs</h4>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="overviewCard">
                          <div className="overviewCardholder">
                            <div className="iconbox">
                              <RiCalendarScheduleLine />
                            </div>
                            <h2 className="redtext">
                              {dashboardDetails?.totalShortlisted || 0}
                            </h2>
                          </div>
                          <h4>Shortlisted Applicants</h4>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="overviewCard">
                          <div className="overviewCardholder">
                            <div className="iconbox">
                              <BsHourglassSplit />
                            </div>
                            <h2 className="redtext">
                              {dashboardDetails?.totalRejected || 0}
                            </h2>
                          </div>
                          <h4>Rejected Applicants</h4>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className={
                          messageList && messageList.length > 0
                            ? "col-lg-9"
                            : "col-lg-12"
                        }
                      >
                        <div className="title">
                          <h2>Recent Job Post</h2>
                        </div>
                        <div className="appliedJobsTable">
                          <div className="table-responsive">
                            <DataTable
                              data={recentPostJobsTableData}
                              columns={columns}
                              isShowPagination={false}
                            />
                          </div>
                        </div>
                      </div>
                      {messageList && messageList?.length > 0 && (
                        <div className="col-lg-3 msshld">
                          <div className="title">
                            <h2>Message</h2>
                          </div>
                          <MessageList
                            messageList={messageList}
                            chatHistory={chatHistory}
                            type="dashboard"
                            user={user}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="findajobmodal"
        centered
      >
        <Modal.Body>
          <div className="afterapplied">
            <h3>Customer Care Executive</h3>
            <div className="aplyinfo">
              <h4>
                <strong>Job Title:</strong> Customer Care Executive
              </h4>
              <h4>
                <strong>Company Name:</strong> TechWave Solutions
              </h4>
              <h4>
                <strong>Location:</strong> San Francisco, CA
              </h4>
              <h4>
                <strong>Application Date:</strong> Oct 12, 2024
              </h4>
              <h4>
                <strong>Job Type:</strong> Full-time
              </h4>
              <h4>
                <strong>Status:</strong> Applied
              </h4>
              <h4>
                <strong>Salary Range:</strong> $900 - $1200/month
              </h4>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default AgntDashboardScreen;
